export default class CompareFunctions {
    public static birthdayCompareStrings(birthDate: string, personalId: string): boolean {
        if (birthDate === "" || personalId === "") {
            return true;
        }

        let personalIdYear = +personalId.substr(0, 2);
        if (personalId.length === 9 || (personalId.length === 10 && personalIdYear >= 54)) {
            personalIdYear += 1900;
        } else {
            personalIdYear += 2000;
        }

        const personalIdMonth = +personalId.substr(2, 2) % 50 % 20;
        const personalIdMonthString = (`${personalIdMonth}`.length < 2) ? `0${personalIdMonth}` : `${personalIdMonth}`;

        const personalIdDay = +personalId.substr(4, 2) % 50;
        const personalIdDayString = (`${personalIdDay}`.length < 2) ? `0${personalIdDay}` : `${personalIdDay}`;

        return `${personalIdYear}-${personalIdMonthString}-${personalIdDayString}` === birthDate;
    }

    public static birthdayCompareToPersonalId(): (birthDateInput: HTMLInputElement, personalIdInput: HTMLInputElement) => boolean {
        return (birthDateInput, personalIdInput) => {
            return CompareFunctions.birthdayCompareStrings(birthDateInput.value, personalIdInput.value);
        };
    }
}
